/**
 * Desktop submenu navigation
 *
 * CSS is responsible for:
 * - :hover
 * - :focus-within
 * - showing and hiding submenus
 *
 * JavaScript is responsible for:
 * - submenu toggle button
 * - aria-expanded
 * - accessible button text
 *
 * Escape and outside clicks are NOT handled here. custom-gsb.js already owns
 * the document-wide click and keydown listeners for the mobile menu and the
 * search; it closes the submenus through window.gsbMenu.
 */

(() => {
  const menu = document.querySelector(".main-menu");

  if (!menu) {
    return;
  }

  /**
   * Returns all submenu buttons.
   */
  const getButtons = () =>
    menu.querySelectorAll(".main-menu-open-submenu-button");

  /**
   * Returns the parent <li>.
   */
  const getItem = (button) => button.closest(".nav-item.deeper");

  /**
   * Updates one submenu button.
   */
  function setExpanded(button, expanded) {
    const item = getItem(button);

    if (!item) {
      return;
    }

    button.setAttribute("aria-expanded", expanded);

    item.classList.toggle("main-menu-open", expanded);

    const text = button.querySelector(".main-menu-open-submenu-button-text");

    const label = expanded ? text?.dataset.close : text?.dataset.open;

    if (text && label) {
      text.textContent = label;
    }
  }

  /**
   * Closes all submenus.
   *
   * Returns the button that was expanded before, or null. The caller needs it
   * to put the focus back when Escape closed the submenu.
   */
  function closeSubmenus() {
    const expandedButton = menu.querySelector(
      '.main-menu-open-submenu-button[aria-expanded="true"]',
    );

    getButtons().forEach((button) => setExpanded(button, false));

    return expandedButton;
  }

  /**
   * Click on submenu button.
   */
  menu.addEventListener("click", (event) => {
    const button = event.target.closest(".main-menu-open-submenu-button");

    if (!button) {
      return;
    }

    event.preventDefault();

    const expanded = button.getAttribute("aria-expanded") === "true";

    closeSubmenus();

    if (!expanded) {
      setExpanded(button, true);
    }
  });

  /**
   * The only entry point for other scripts.
   */
  window.gsbMenu = { closeSubmenus };
})();
